import { DateTime } from 'luxon'

import { getResource } from '@/shared/constants/resources'
import type { Blocker, TimeBlocker } from '@/types/blocker'

const GENERIC = 'Bloqueado'

/**
 * Rótulo curto do bloqueio, para o card da vitrine.
 *
 * Não é a mensagem do alerta. `getBlockMessage` produz uma sentença inteira
 * ("Para acessar este recurso, é necessário concluir a/o missão X.") que não
 * cabe no card, e truncá-la come justamente o nome do recurso — a única parte
 * que responde "por que não consigo?". Aqui o rótulo é montado das mesmas
 * partes que aquela sentença usa, e por isso já nasce em uma linha.
 *
 * A vitrine nomeia o que falta; o toque abre o modal, que explica.
 */
export const resolveBlockLabel = (
  blocker: Blocker | TimeBlocker | undefined
): string => {
  if (!blocker) return GENERIC

  if (blocker.type === 'time') {
    const until = DateTime.fromISO(blocker.until)
    if (!until.isValid) return GENERIC

    // Sem data: a lojinha abre e fecha dentro do dia do evento, então a hora é
    // a informação que o Participante usa, e a data gastaria a linha inteira.
    return `Libera às ${until.toFormat(until.minute === 0 ? "H'h'" : "H'h'mm")}`
  }

  // `blockRedo` não é destravável pelo Participante — não há o que nomear como
  // "falta", e prometer uma ação que não existe é pior que o genérico.
  if (blocker.condition === 'blockRedo') return GENERIC

  let resource
  try {
    resource = getResource(blocker.resource?.type)
  } catch {
    // Tipo que o catálogo de recursos não conhece: o modal ainda explica.
    return GENERIC
  }

  const name = blocker.resource?.name?.trim() || resource.humanName.singular

  // Parceiro se conclui por check-in no estande, não por "concluir o Parceiro".
  // Nomear o gesto é o que economiza a pergunta no balcão.
  if (blocker.resource?.type === 'partner') return `Falta: check-in na ${name}`

  return `Falta: ${name}`
}
